import React, { useCallback, useState } from "react";

import {
  SizeAndFitSheet,
  type SizeAndFitButtonProps,
} from "~/templates/product/SizeAndFitSheet";

import { Button, IconFootbed, IconChevron } from "@bared/ui";

export function FootbedButton({
  gender,
  isFitKitIncluded,
}: SizeAndFitButtonProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSheetToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [isOpen]);

  return (
    <>
      <div>
        <Button
          variant="round"
          size="small"
          onClick={handleSheetToggle}
          className="flex items-center gap-pico !px-[10px] font-medium"
        >
          <IconFootbed className="w-mini md:w-[20px]" />
          Secret Support
          <IconChevron className="w-[10px] rotate-[270deg]" />
        </Button>
      </div>

      <SizeAndFitSheet
        activeTab="biomechanicalFootbed"
        isOpen={isOpen}
        handleSheetToggle={handleSheetToggle}
        gender={gender}
        isFitKitIncluded={isFitKitIncluded}
      />
    </>
  );
}
